import { InfoOutlined, Close as CloseIcon } from "@mui/icons-material";
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

export default function ResumeReachedLimitModal(props) {
    const { open, onClose, enableDeleteResumeButton } = props;
    const { multiLanguageData } = useSelector((state) => state?.main);
    const LanguageData = multiLanguageData?.JobPostings || {};
    const {
        TEXT_MAX_RESUMES_REACHED = English.JobPostings.TEXT_MAX_RESUMES_REACHED,
        TEXT_MAX_RESUMES_BODY = English.JobPostings.TEXT_MAX_RESUMES_BODY,
        TEXT_MAX_RESUMES_DELETE_HINT = English.JobPostings.TEXT_MAX_RESUMES_DELETE_HINT,
        TEXT_CANCEL = English.JobPostings.TEXT_CANCEL,
        TEXT_YES = English.JobPostings.TEXT_YES
    } = LanguageData || {};

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 3,
                    boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
                    position: "relative",
                },
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 10,
                    top: 10,
                    color: "text.secondary",
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ textAlign: "center", px: 3, py: 2 }}>
                {/* Icon */}
                <Box
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        backgroundColor: `${BIBlue}20`,
                        color: BIBlue,
                        mb: 2.5,
                    }}
                >
                    <InfoOutlined sx={{ fontSize: 38 }} />
                </Box>

                {/* Title */}
                <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ mb: 1, color: "text.primary" }}
                >
                    {TEXT_MAX_RESUMES_REACHED}
                </Typography>

                {/* Description */}
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 4, lineHeight: 1.6 }}
                >
                    {TEXT_MAX_RESUMES_BODY}
                    <br />
                    {TEXT_MAX_RESUMES_DELETE_HINT}
                </Typography>

                {/* Buttons */}
                <Stack direction="row" spacing={2}>
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: 3,
                            py: 1.2,
                        }}
                    >
                        {TEXT_CANCEL}
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={enableDeleteResumeButton}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: 3,
                            py: 1.2,
                            backgroundColor: BIBlue,
                            "&:hover": {
                                backgroundColor: "#004d9e",
                            },
                        }}
                    >
                        {TEXT_YES}
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
